import { makeAutoObservable, runInAction } from 'mobx';
import type { RootStore } from './root-store';
import { SourceSurveyEnum } from '../../defs/api';

export class SourceSurveyStore {
    rootStore: RootStore;

    isOpened: boolean = false;

    loading = false;

    source: SourceSurveyEnum | null = null;

    initializedForUserId: string | null = null;

    hasUserSelectedSource = false;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this, {
            rootStore: false,
        });
    }

    async updateSourceSurvey(): Promise<boolean> {
        if (!this.source) {
            return false;
        }

        this.startLoading();

        try {
            await this.rootStore.apiClient.userController.userControllerUpdateSourceSurvey({
                sourceSurveyDto: {
                    sourceSurvey: this.source,
                },
            });
            await this.rootStore.authStore.fetchUserProfile();
            runInAction(() => {
                this.closeDialog();
            });
            return true;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            this.rootStore.alertStore.setErrorMessageByStatus(e.message);
            return false;
        } finally {
            runInAction(() => {
                this.stopLoading();
            });
        }
    }

    openDialog(): void {
        this.isOpened = true;
        this.rootStore.alertStore.setModalPlacement();
    }

    closeDialog(): void {
        this.isOpened = false;
        this.rootStore.alertStore.setDefaultPlacement();
    }

    setSource(source: SourceSurveyEnum | null): void {
        this.source = source;
        this.hasUserSelectedSource = true;
    }

    initializeSourceForUser(userId: string, suggestedSource: SourceSurveyEnum | null): void {
        if (this.initializedForUserId === userId) {
            if (!this.hasUserSelectedSource && this.source === null && suggestedSource) {
                this.source = suggestedSource;
            }
            return;
        }

        this.initializedForUserId = userId;
        this.hasUserSelectedSource = false;
        this.source = suggestedSource;
    }

    reset(): void {
        this.isOpened = false;
        this.loading = false;
        this.source = null;
        this.initializedForUserId = null;
        this.hasUserSelectedSource = false;
        this.rootStore.alertStore.setDefaultPlacement();
    }

    startLoading(): void {
        this.loading = true;
    }

    stopLoading(): void {
        this.loading = false;
    }
}
